import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as gql from './gql'

/**
 * API used by configurable Space dimension filter features.
 */
@ngCore.Injectable()
export class Api {
  /**
   * Gets selectable records for one Space dimension entity.
   */
  public getOptions({
    context,
    criteria,
  }: Api.GetOptions.Params): rxjs.Observable<
    readonly ents.extra.space.Filter.Option[]
  > {
    const { ancestorEntityId, ancestorIds, entityId } = criteria
    const hasAncestorFilter = Boolean(ancestorEntityId && ancestorIds?.length)

    return gql.queries.spaceFilterOptions.execute({
      ...context,
      ancestorEntityId: hasAncestorFilter ? ancestorEntityId : undefined,
      ancestorIds: hasAncestorFilter ? ancestorIds : undefined,
      entityId,
    })
  }
}

export namespace Api {
  export namespace GetOptions {
    export interface Params {
      readonly context: ents.core.admin.Context.ForScenario
      readonly criteria: ents.extra.space.Filter.Option.Criteria
    }
  }
}
